import React from 'react';
import { nextGameStyle as styles } from './nextGame.tailwind';
import Button from '../../shared/Button/Button';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import routeConstant from '../../../lib/constants/routeConstant';
import { storage } from '../../../config/storage';

const NextGame = () => {
  const navigate = useNavigate();
  const { isSignedIn } = useSelector((state) => state.user);

  const handleExploreTokens = () => {
    if (!isSignedIn) {
      storage.setInLocalStorage.navigateOnLogin(routeConstant.SELECT_SPORT_PAGE);
    }
    navigate(routeConstant.SELECT_SPORT_PAGE);
  };

  return (
    <section className={styles.section_wrapper}>
      <div className={styles.container}>
        {/* Heading */}
        <h2 className={styles.heading}>
          THE NEXT <br />
          <span className={styles.highlight}>HOME GAME</span> IS WAITING.
        </h2>

        {/* Match Info Subtitle */}
        <p className={styles.subtitle}>
          FALCONS VS RAMS — MON, DEC 29 · 7:15 PM CDT
        </p>

        {/* Button */}
        <Button variant='primary' className={styles.explore_btn} onClick={handleExploreTokens}>
          Donate Now
        </Button>
      </div>
    </section>
  );
};

export default NextGame;
